import { NgModule, LOCALE_ID, Injectable, inject,ErrorHandler } from '@angular/core';
import { RouterLink } from '@angular/router';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter, provideMomentDateAdapter } from '@angular/material-moment-adapter';
import { BrowserModule, HammerModule, HammerGestureConfig, HAMMER_GESTURE_CONFIG } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ServiceWorkerModule } from '@angular/service-worker';
import { HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatDialogModule } from '@angular/material/dialog';
import { MatMenuModule } from '@angular/material/menu';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { provideNgIconLoader, provideNgIconsConfig, withCaching } from '@ng-icons/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TourMatMenuModule, TourStepTemplateComponent } from 'ngx-ui-tour-md-menu';

import { MY_FORMATS } from './utils/moment-config-datepicker';

import { PageModules } from 'src/app/utils/pageModules';
import { AlertConfirmModule } from './components/alert-confirm/alert-confirm.module';
import { MenuNovaCotacaoModule } from './components/menu-nova-cotacao/menu-nova-cotacao.module';
import { ToolBarActionsModule } from './components/tool-bar-actions/tool-bar-actions.module';
import { ShowIfAuthorizedModule } from 'src/app/directives/show-if-authorized/show-if-authorized.module';

import { FiltroComponent} from './components/filtro/filtro.component';
import { NavbarMobileComponent } from './components/navbar-mobile/navbar-mobile.component';
import { MenuMobileComponent } from './components/menu-mobile/menu-mobile.component';
import { TourStepComponent } from './components/tour-step/tour-step.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { HeaderComponent } from './components/header/header.component';
import { registerLocaleData } from '@angular/common';
import { LazyLoadErrorHandler } from './lazy-load-error.handler';

import { DeviceDetectorService } from 'ngx-device-detector';
import { TokenInterceptorService } from './services/token-interceptor.service';
import { ApiInterfaceService } from 'src/app/services/api/api-interface.service';
import { ApiApiceService } from 'src/app/services/api/api-apice.service';
import { UtilsService } from './services/utils.service';

import { AuthGuard } from './guards/auth-guard.guard';
import { environment } from '../environments/environment';
import { GaEventModule } from './directives/ga-event/ga-event.module';

import ptBr from '@angular/common/locales/pt';
import moment from 'moment';
import 'moment/locale/pt-br';

moment.locale('pt-br');
registerLocaleData(ptBr);

@Injectable()
export class HammerConfig extends HammerGestureConfig  {
  buildHammer(element: HTMLElement): HammerManager {
      return new Hammer.Manager(element, {
        touchAction: 'auto',
        inputClass: window.innerWidth > 870 ? Hammer.PointerEventInput : Hammer.TouchInput,
        recognizers: [
          [Hammer.Pan, {
            direction: Hammer.DIRECTION_ALL
          }],
          [Hammer.Press],
          [Hammer.Swipe, {direction: Hammer.DIRECTION_HORIZONTAL}],
          [Hammer.Tap, {enable: false}]
        ]
    });
  }
}
@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HammerModule,
    MatCheckboxModule,
    ReactiveFormsModule,
    FormsModule,
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production,  registrationStrategy: 'registerWhenStable' }),
    MatToolbarModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    MatIconModule,
    MatListModule,
    MatSnackBarModule,
    MenuNovaCotacaoModule,
    ShowIfAuthorizedModule,
    FiltroComponent,
    MatDialogModule,
    NgbModule,
    PageModules,
    MatMenuModule,
    AlertConfirmModule,
    ToolBarActionsModule,
    NavbarMobileComponent,
    RouterLink,
    MenuMobileComponent,
    TourStepTemplateComponent,
    TourStepComponent,
    TourMatMenuModule,
    SidebarComponent,
    HeaderComponent,
    GaEventModule
  ],
  providers: [
    AuthGuard,
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptorService, multi: true },
    { provide: ApiInterfaceService, useClass: ApiApiceService },
    { provide: HAMMER_GESTURE_CONFIG, useClass: HammerConfig},
    { provide: 'api', useClass: ApiApiceService  },
    { provide: 'utils', useClass: UtilsService  },
    { provide: ErrorHandler, useClass: LazyLoadErrorHandler },
    DeviceDetectorService,
    provideHttpClient(withInterceptorsFromDi()),

    provideMomentDateAdapter(),
    { provide: LOCALE_ID, useValue: 'pt-BR' },
    { provide: MAT_DATE_LOCALE, useValue: 'pt-BR' },
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]},
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },

    provideNgIconLoader(name => {
      const http = inject(HttpClient);
      return http.get(`/assets/img/icons/${name}.svg`, { responseType: 'text'});
    },
    withCaching()),

    provideNgIconsConfig({
      size: '24px',
      strokeWidth: 1.8
    }),
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
